class Accordion {

  private element: HTMLElement;
  private triggerElement: HTMLElement;
  private contentElement: HTMLElement;
  private contentInnerElement: HTMLElement;
  private triggerTextElement: HTMLElement;
  private triggerIconElement: HTMLElement;
  private textOpen: string;
  private textClose: string;

  private contentShowTransitionEndBind: () => void;
  private contentHideTransitionEndBind: () => void;
  constructor(element: HTMLElement) {
    this.element = element;
    this.triggerElement = this.element.querySelector(".j-ms-accordion-trigger") as HTMLElement;
    this.contentElement = this.element.querySelector(".j-ms-accordion-content") as HTMLElement;
    this.contentInnerElement = this.element.querySelector(".j-ms-accordion-content-inner") as HTMLElement;
    this.triggerTextElement = this.element.querySelector(".j-ms-accordion-trigger-text") as HTMLElement;
    this.triggerIconElement = this.element.querySelector(".j-ms-accordion-trigger-icon") as HTMLElement;
    this.textOpen = this.triggerElement.getAttribute("data-text-open") as string;
    this.textClose = this.triggerElement.getAttribute("data-text-close") as string;

    this.contentShowTransitionEndBind = this.contentShowTransitionEnd.bind(this);
    this.contentHideTransitionEndBind = this.contentHideTransitionEnd.bind(this);

    this.triggerElement.addEventListener("click", () => {
      this.toggleContent();
    });
  }

  private toggleContent() {
    if (this.element.classList.contains("is-open")) {
      this.closeContent();
    } else {
      this.openContent();
    }
  }

  private changeAria() {
    if (this.element.classList.contains("is-open")) {
      this.triggerElement.setAttribute("aria-expanded", "true");
      this.contentElement.removeAttribute("hidden");
    } else {
      this.triggerElement.setAttribute("aria-expanded", "false");
      this.contentElement.setAttribute("hidden", "");
    }
  }

  private changeText() {
    if (this.element.classList.contains("is-open")) {
      this.triggerTextElement.textContent = this.textClose;
    } else {
      this.triggerTextElement.textContent = this.textOpen;
    }
  }

  private changeIcon() {
    const useElement = this.triggerIconElement.querySelector("use") as SVGUseElement;
    if (this.element.classList.contains("is-open")) {
      useElement.setAttribute("href", "/inc/img/manual-search/sprite-icons.svg?#icons-minus");
    } else {
      useElement.setAttribute("href", "/inc/img/manual-search/sprite-icons.svg?#icons-plus");
    }
  }

  private openContent() {
    this.element.classList.add("is-open");
    this.changeAria();
    this.changeText();
    this.changeIcon();
    setTimeout(() => {
      this.openContentMain();
    });
  }

  private closeContent() {
    this.element.classList.remove("is-open");
    this.setContentHeight();
    setTimeout(() => {
      this.closeContentMain();
    });
  }

  private openContentMain() {
    this.removeTransitionEndListener();
    this.setContentHeight();
    this.contentElement.addEventListener("transitionend", this.contentShowTransitionEndBind);
  }

  private setContentHeight() {
    const height = this.contentInnerElement.offsetHeight;
    this.contentElement.style.height = `${height}px`;
  }

  private closeContentMain() {
    this.removeTransitionEndListener();
    this.contentElement.addEventListener("transitionend", this.contentHideTransitionEndBind);
    this.contentElement.style.height = "0px";
  }

  private removeTransitionEndListener() {
    this.contentElement.removeEventListener("transitionend", this.contentShowTransitionEndBind);
    this.contentElement.removeEventListener("transitionend", this.contentHideTransitionEndBind);
  }


  private contentShowTransitionEnd() {
    this.contentElement.style.height = "auto";
    this.removeTransitionEndListener();
  }

  private contentHideTransitionEnd() {
    this.contentElement.style.height = "0px";
    this.removeTransitionEndListener();
    this.changeAria();
    this.changeText();
    this.changeIcon();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionElements = document.querySelectorAll(".j-ms-accordion");
  accordionElements.forEach((element) => {
    new Accordion(element as HTMLElement);
  });
});
